var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600.63 387.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-1,.cls-2{stroke-width:0px;}.cls-3{clip-path:url(#clippath);}.cls-2{fill:#66767a;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 600.63,
    height: 387.69
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32420",
    className: "cls-2",
    d: "M568.24,196.85c-16.49-16.75-37.86-27.85-61.04-31.71.18-2.58.27-5.13.27-7.64,0-58.57-47.48-106.05-106.05-106.05-13.59,0-27.06,2.61-39.66,7.7C319.17-2.88,234.38-18.63,172.36,23.95c-36.32,24.94-58.33,65.9-59.1,109.94C43.38,141.44-7.16,204.21.39,274.1c7,64.76,61.75,113.79,126.89,113.61h128.4v-84.44h-51.89c-2.67,0-4.82-2.17-4.82-4.83,0-1.11.38-2.18,1.08-3.04l94-115.53c1.68-2.07,4.72-2.38,6.79-.69.25.21.48.44.69.69l94,115.53c1.68,2.07,1.37,5.11-.7,6.79-.86.7-1.93,1.08-3.04,1.08h-51.89v84.44h148.6c61.88.01,112.05-50.14,112.06-112.02,0-29.51-11.63-57.84-32.39-78.82"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload01);
export default __webpack_public_path__ + "static/media/upload-01.79bbdd5126a87c95b19c180857b0ab48.svg";
export { ForwardRef as ReactComponent };